export default [
    {
        path: '/evoucher/transacciones/facturas',
        name: 'evoucher-transacciones-facturas',
        component: () => import('@/views/pages/evoucher/transacciones/Facturas.vue'),
        meta: {
            title: 'i18n:evoucher.transacciones.facturas.title',
            resource: 'Evoucher',
            action: 'ver-evoucher-transacciones-facturas',
            pageTitle: 'evoucher.transacciones.facturas.title',
            breadcrumb: [
                {
                    text: 'evoucher.title',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'evoucher.transacciones.facturas.title',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/evoucher/transacciones/notas-debito',
        name: 'evoucher-transacciones-notas-debito',
        component: () => import('@/views/pages/evoucher/transacciones/NotasDebito.vue'),
        meta: {
            title: 'i18n:evoucher.transacciones.notas-debito.title',
            resource: 'Evoucher',
            action: 'ver-evoucher-transacciones-notas-debito',
            pageTitle: 'evoucher.transacciones.notas-debito.title',
            breadcrumb: [
                {
                    text: 'evoucher.title',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'evoucher.transacciones.notas-debito.title',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/evoucher/transacciones/notas-credito',
        name: 'evoucher-transacciones-notas-credito',
        component: () => import('@/views/pages/evoucher/transacciones/NotasCredito.vue'),
        meta: {
            title: 'i18n:evoucher.transacciones.notas-credito.title',
            resource: 'Evoucher',
            action: 'ver-evoucher-transacciones-notas-credito',
            pageTitle: 'evoucher.transacciones.notas-credito.title',
            breadcrumb: [
                {
                    text: 'evoucher.title',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'evoucher.transacciones.notas-credito.title',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/evoucher/transacciones/guias-remision',
        name: 'evoucher-transacciones-guias-remision',
        component: () => import('@/views/pages/evoucher/transacciones/GuiasRemision.vue'),
        meta: {
            title: 'i18n:evoucher.transacciones.guias-remision.title',
            resource: 'Evoucher',
            action: 'ver-evoucher-transacciones-guias-remision',
            pageTitle: 'evoucher.transacciones.guias-remision.title',
            breadcrumb: [
                {
                    text: 'evoucher.title',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'evoucher.transacciones.guias-remision.title',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/evoucher/transacciones/liquidacion-compra',
        name: 'evoucher-transacciones-liquidacion-compra',
        component: () => import('@/views/pages/evoucher/transacciones/LiquidacionCompra.vue'),
        meta: {
            title: 'i18n:evoucher.transacciones.liquidacion-compra.title',
            resource: 'Evoucher',
            action: 'ver-evoucher-transacciones-liquidacion-compra',
            pageTitle: 'evoucher.transacciones.liquidacion-compra.title',
            breadcrumb: [
                {
                    text: 'evoucher.title',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'evoucher.transacciones.liquidacion-compra.title',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/evoucher/transacciones/comprobante-retencion',
        name: 'evoucher-transacciones-comprobante-retencion',
        component: () => import('@/views/pages/evoucher/transacciones/ComprobanteRetencion.vue'),
        meta: {
            title: 'i18n:evoucher.transacciones.comprobante-retencion.title',
            resource: 'Evoucher',
            action: 'ver-evoucher-transacciones-comprobante-retencion',
            pageTitle: 'evoucher.transacciones.comprobante-retencion.title',
            breadcrumb: [
                {
                    text: 'evoucher.title',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'evoucher.transacciones.comprobante-retencion.title',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/evoucher/matenimiento/cargar-comprobantes',
        name: 'evoucher-matenimiento-cargar-comprobantes',
        component: () => import('@/views/pages/evoucher/matenimiento/CargarComprobante.vue'),
        meta: {
            title: 'i18n:evoucher.matenimiento.cargar-comprobantes.title',
            resource: 'Evoucher',
            action: 'ver-evoucher-matenimiento-cargar-comprobantes',
            pageTitle: 'evoucher.matenimiento.cargar-comprobantes.title',
            breadcrumb: [
                {
                    text: 'evoucher.title',
                },
                {
                    text: 'Matenimiento',
                },
                {
                    text: 'evoucher.matenimiento.cargar-comprobantes.title',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/evoucher/dashboard/vouchers',
        name: 'evoucher-dashboard-vouchers',
        component: () => import('@/views/pages/evoucher/dashboard/Vouchers.vue'),
        meta: {
            title: 'i18n:evoucher.dashboard.vouchers.title',
            resource: 'Evoucher',
            action: 'ver-evoucher-dashboard-vouchers',
            pageTitle: 'evoucher.dashboard.vouchers.title',
            breadcrumb: [
                {
                    text: 'evoucher.title',
                },
                {
                    text: 'Dashboard',
                },
                {
                    text: 'evoucher.dashboard.vouchers.title',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/evoucher/transacciones/firmar-documento',
        name: 'evoucher-transacciones-firmar-documento',
        component: () => import('@/views/pages/evoucher/transacciones/FirmarDocumento.vue'),
        meta: {
            title: 'i18n:evoucher.transacciones.firmar-documento.title',
            resource: 'Evoucher',
            action: 'ver-evoucher-transacciones-firmar-documento',
            pageTitle: 'evoucher.transacciones.firmar-documento.title',
            breadcrumb: [
                {
                    text: 'evoucher.title',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'evoucher.transacciones.firmar-documento.title',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/evoucher/matenimiento/firma',
        name: 'evoucher-matenimiento-firma',
        component: () => import('@/views/pages/evoucher/matenimiento/Firma.vue'),
        meta: {
            title: 'i18n:evoucher.matenimiento.firma.title',
            resource: 'Evoucher',
            action: 'ver-evoucher-matenimiento-firma',
            pageTitle: 'evoucher.matenimiento.firma.title',
            breadcrumb: [
                {
                    text: 'evoucher.title',
                },
                {
                    text: 'Matenimiento',
                },
                {
                    text: 'evoucher.matenimiento.firma.title',
                    active: true,
                },
            ],
        },
    },
]
